import React, { Component } from 'react'
import Layout from '../components/layout'
import './StaticPage.scss'

export default class Impressum extends Component {
  render () {
    const isFr = window.location.href.indexOf('fr-FR') > -1

    return (
      <Layout {...this.props} className="category">
        <div className="static-page">
          {isFr ? <ImpressumFr /> : <ImpressumDe />}
        </div>
      </Layout>
    )
  }
}

const ImpressumDe = () => (
  <>
    <h1>Impressum</h1>

    <h2>Angaben gemäss Schweizer Recht</h2>
    <p>
      <strong>Vögeli AG</strong><br />
      Sägestrasse 23A<br />
      CH-3550 Langnau im Emmental
    </p>

    <h2>Kontakt</h2>
    <p>
      Telefon: <a href="tel:+41344091010">+41 34 409 10 10</a><br />
      E-Mail: <a href="mailto:voegeli@voegeli.ch">voegeli@voegeli.ch</a><br />
      Web: <a href="https://www.voegeli.ch/de/" target="_blank" rel="noreferrer">www.voegeli.ch</a>
    </p>

    <h2>Handelsregistereintrag</h2>
    <p>
      Eingetragener Firmenname: Vögeli AG<br />
      Handelsregister des Kantons Bern
    </p>

    <h2>Haftungsausschluss</h2>
    <p>
      Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen. Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller Art, welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen, durch Missbrauch der Verbindung oder durch technische Störungen entstanden sind, werden ausgeschlossen.
    </p>

    <h2>Urheberrechte</h2>
    <p>
      Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf dieser Website gehören ausschliesslich der Firma Vögeli AG oder den speziell genannten Rechtsinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche Zustimmung der Urheberrechtsträger im Voraus einzuholen.
    </p>
  </>
)

const ImpressumFr = () => (
  <>
    <h1>Mentions légales</h1>

    <h2>Informations conformément au droit suisse</h2>
    <p>
      <strong>Vögeli AG</strong><br />
      Sägestrasse 23A<br />
      CH-3550 Langnau im Emmental
    </p>

    <h2>Contact</h2>
    <p>
      Téléphone : <a href="tel:+41344091010">+41 34 409 10 10</a><br />
      E-mail : <a href="mailto:voegeli@voegeli.ch">voegeli@voegeli.ch</a><br />
      Web : <a href="https://www.voegeli.ch/de/" target="_blank" rel="noreferrer">www.voegeli.ch</a>
    </p>

    <h2>Registre du commerce</h2>
    <p>
      Raison sociale : Vögeli AG<br />
      Registre du commerce du canton de Berne
    </p>

    <h2>Clause de non-responsabilité</h2>
    <p>
      L'auteur n'assume aucune responsabilité quant à l'exactitude, la précision, l'actualité, la fiabilité et l'exhaustivité des informations publiées. Toute responsabilité pour des dommages matériels ou immatériels résultant de l'accès ou de l'utilisation des informations publiées est exclue.
    </p>

    <h2>Droits d'auteur</h2>
    <p>
      Les droits d'auteur et tous les autres droits sur les contenus, images, photos ou autres fichiers de ce site appartiennent exclusivement à la société Vögeli AG. La reproduction de tout élément nécessite l'accord écrit préalable des détenteurs des droits d'auteur.
    </p>
  </>
)
